import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";
import { delay } from "./Utils";

const CreateNote = (modal, editor) => {

  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  let url = document.URL;

  const activeTabId = getQueryParam("tab");
  if (activeTabId) {
    url = document.URL;
  } else {
    url = `${document.URL}&tab=notes`;
  }

  const form = document.getElementById("create_note_form");
  if (form) {
    // ui
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      // show ui
      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      // add data to form
      const data = new FormData(form);
      data.append("action", "create_note");
      data.append("note_content", editor.getContents());

      // perform action
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Save";
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: url,
            });
            modal.hide();
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          spinner.classList.add("hidden!");
          spinnerText.textContent = "Save";
          createToast({
            type: "error",
            message: "System Error!",
            duration: 1000,
          });
        });
    });
  }
};

export { CreateNote };
